import React from 'react';
import { Redirect } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";


export const MINOR_CHOICES = [
  // group label, minor choices
  ["À des événements climatiques extrêmes", {
    1: {label: "Canicule"},
    2: {label: "Sécheresse exceptionnelle"},
    3: {label: "Pluie diluvienne"},
    4: {label: "Ouragan, cyclone ou tornade"},
    5: {label: "Feu de forêt"},
    6: {label: "Grêle, neige ou gel exceptionnel"}
  }],
  ["À des changements progressifs", {
    7: {label: "Augmentation des températures moyennes"},
    8: {label: "Baisse ou hausse des précipitation (pluie et neige)"},
    9: {label: "Ressources en eau plus faibles (lacs, rivières, nappes phréatiques)"},
    10: {label: "Érosion du littoral"},
    11: {label: "Fonte des glaciers"},
  }],
  ["À des perturbations sur les plantes et les animaux", {
    12: {label: "Plantes perturbées"},
    13: {label: "Animaux perturbés"},
  }],
  ["Autres", {
    14: {label: "Autres"},
  }]
];

export const TESTIMONIAL_CHOICES = {
  1: {
    label: "Je suis inquiet·e mais je ne subis pas d'impact direct",
    major_choices: {
      1: {
        label: "Je suis angoissé·e par rapport à l'avenir",
        icon: 'avenir'
      },
      2: {
        label: "Ça m'a fait changer mon mode de vie",
        icon: 'mode-vie'
      }
    },
    minor_choices: [...MINOR_CHOICES]
  },
  2: {
    label: "Je subis un impact direct et concret sur ma vie",
    major_choices: {
      1: {
        label: "Sur ma santé",
        icon: 'sante',
      },
      2: {
        label: "Sur mes revenus",
        icon: 'revenu'
      },
      3: {
        label: "Sur mon logement",
        icon: 'logement',
      },
      4: {
        label: "Dans ma vie quotidienne",
        icon: 'quotidien'
      }
    },
    minor_choices: [...MINOR_CHOICES]
  },
  3: {
    label: "Je constate un impact direct sur la nature",
    major_choices: {
      1: {
        label: "Des perturbations sur les plantes",
        icon: 'plante'
      },
      2: {
        label: "Des perturbations sur les animaux",
        icon: 'animaux'
      },
      3: {
        label: "Des perturbations sur les paysages",
        icon: 'paysage'
      }
    },
    minor_choices: [
      MINOR_CHOICES[0],
      MINOR_CHOICES[1]
    ]
  }
}


export default class TestimonialWizard extends React.Component {

  constructor(props) {
    super(props);
    this.currentStep = 0;
    this.state = {
      finished: false,
      steps: {
        testimonialChoice: null,
        majorChoice: null,
        minorChoices: null
      }
    };
  }

  setStepState = (step, callback) => {
    this.setState((state) => ({
      steps: {
        ...state.steps,
        ...step
      }
    }), callback)
  }

  goBackTo = (stepName) => {
    this.setStepState({
      [stepName]: null
    }, this.onChange);
  }

  onChange = () => {
    this.props.onChange(this.state.steps);
  }

  setTestimonial = (value) => {
    this.setStepState({
      testimonialChoice: value
    }, this.onChange);
  }

  setMajor = (value) => {
    this.setStepState({
      majorChoice: value
    }, this.onChange);
  }

  setMinor = (values) => {
    this.setStepState({
      minorChoices: values,
    }, this.onFinished);
  }

  onStarted = () => {
    this.props.onStarted(this.state.steps);
  }

  onFinished = () => {
    this.setState({
      finished: true
    }, this.onChange);
  }

  getStepComponent() {
    const { onClose } = this.props;
    const {
      testimonialChoice, majorChoice, minorChoices
    } = this.state.steps;

    if (testimonialChoice === null) {
      return ([1,
        <TestimonialChoice
          onClose={onClose}
          onChange={this.setTestimonial}
        />
      ]);
    } else if (majorChoice === null) {
      return ([2,
        <MajorChoice
          onClose={onClose}
          testimonial={testimonialChoice}
          onChange={this.setMajor}
          goBack={() => this.goBackTo('testimonialChoice')}
        />
      ]);
    } else {
      return ([3,
        <MinorChoice
          onClose={onClose}
          testimonial={testimonialChoice}
          onChange={this.setMinor}
          goBack={() => this.goBackTo('majorChoice')}
        />
      ]);
    }
  }

  render() {
    const { onClose } = this.props;
    const { finished } = this.state;

    if (finished) {
      return <Redirect to="/add"/>
    }
    const [stepKey, stepComponent] = this.getStepComponent();
    return (
      <TransitionGroup>
        {/*
          See: https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/examples/Animation/index.js
          no different than other usage of
        CSSTransition, just make sure to pass
        `location` to `Switch` so it can match
        the old location as it animates out
        */}
        <CSSTransition
          key={stepKey}
          classNames="alert"
          timeout={300}
        >
          {stepComponent}
        </CSSTransition>
      </TransitionGroup>
    );
  }
}


const TestimonialChoice = ({ onClose, onChange }) => {

  const makeClickHandler = (value) => () => onChange(value);
  return (
    <div id="gp-popup-choix" className="gp-popup-choix">
      <div class="gp-close-icon" onClick={onClose}>
        <span class="icon">
          <i class="fa fa-window-close"></i>
        </span>
      </div>

      <div class="gp-titre-s4">
        Je suis témoin du dérèglement climatique et&nbsp;:
      </div>

      <ul class="gp-action-form">
        {Object.entries(TESTIMONIAL_CHOICES).map(([key, {label}]) => (
          <li key={key}>
            <a onClick={makeClickHandler(key)}>
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}


const MajorChoice = ({ onClose, onChange, testimonial, goBack }) => {
  const choices = TESTIMONIAL_CHOICES[testimonial].major_choices;

  const makeClickHandler = (value) => () => onChange(value);

  return (
    <div id="gp-popup-choix" className="gp-popup-choix">
      <div class="gp-close-icon" onClick={onClose}>
        <span class="icon">
          <i class="fa fa-window-close"></i>
        </span>
      </div>

      <div class="gp-titre-s4">
        Plus précisément&nbsp;:
      </div>

      <ul class="gp-action-form">
        {Object.entries(choices).map(([key, {label, icon}]) => (
          <li key={key}>
            <a onClick={makeClickHandler(key)}>
              <span className={`ico-${icon}`}></span>
              <span class="button_label">
                {label}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div class="field">
        <div class="columns gp-send-columns" >
          <div class="column gp-send-cancel-column" >
            <div class="control" >
              <button
                className="button is-link gp-button-form-cancel"
                onClick={goBack}
              >
                Retour
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


class MinorChoice extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  checkHandler = (value) => (evt) => {
    this.setState({
      [value]: evt.target.checked
    });
  }

  onSubmit = () => {
    // list only checked keys (those with a true-ish` value in state)
    const values = this.getSelected();
    if (this.isValid(values)) {
      this.props.onChange(values)
    }
  }

  getSelected = () => {
    return Object.keys(this.state).filter((key) => this.state[key]);
  }

  tooMuchSelected = (values) => {
    return values.length > 4;
  }

  isValid = (values) => {
    return values.length > 0 && !this.tooMuchSelected(values);
  }

  render() {
    const { onClose, testimonial, goBack } = this.props;
    const choicesGroups = TESTIMONIAL_CHOICES[testimonial].minor_choices;

    const selected = this.getSelected();

    const hasTooMuch = this.tooMuchSelected(selected);
    const hasErrors = !this.isValid(selected);

    return (
      <div id="gp-popup-choix" className="gp-popup-choix">
        <div class="gp-close-icon" onClick={onClose}>
          <span class="icon">
            <i class="fa fa-window-close"></i>
          </span>
        </div>

        <div class="gp-titre-s4">
          C'est lié&nbsp;:
        </div>


        {choicesGroups.map(([groupLabel, choices]) => (
          <div key={groupLabel}>
            <div className="gp-titre-s4">
              {groupLabel}
            </div>
            <div class="gp-action-form gp-action-large" style={{
              'position': 'relative',
              'width': '60%',
              'marginLeft': 'auto',
              'marginRight': 'auto'
            }}>
              {Object.entries(choices).map(([key, {label}]) => (
                <div class="field" key={key}>
                  <label class="control control-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state[key] || false}
                      onChange={this.checkHandler(key)}
                    />
                    {label}
                    <div class="control_indicator"></div>
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}

        {hasTooMuch ? (
          <div className="field">
            <p className="help is-danger">
              4 choix maximum
            </p>
          </div>
        ) : ''}

        <div class="field">
          <div class="gp-action-form-large" >
            <div class="gp-send-cancel-column is-right" >
              <div class="control">
                <button
                  class="button is-link gp-button-form-cancel "
                  onClick={goBack}
                >
                  Retour
                </button>
              </div>
            </div>
            <div class="gp-send-send-column is-half is-left">
              <div class="control"  >
                <button
                  class="button is-link  gp-button-form-submit "
                  onClick={this.onSubmit}
                  disabled={hasErrors}
                >
                  Suivant
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
